import { palette } from './palette';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },

  '.smilebody-container': {
    '& .normal-text': {
      fontWeight: 300,
    },

    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section, .faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
      {
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'center',
        background: palette.background.main,
      },
    '@media(max-width: 900px)': {
      '& .header-wrapper': {
        paddingBottom: '10px',
      },
    },

    '& .checkout-outer-container, .plan-selection-container': {
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      background: palette.background.main,

      '@media(min-width: 900px)': {
        marginBottom: '60px',
      },

      '& .hero-section-alternate': {
        height: 'auto !important',
        paddingBottom: 0,

        '& .section-alternate__content': {
          '@media(min-width: 900px)': {
            padding: '0 48px',
          },
        },
        '& .hero-title': {
          fontSize: '64px',
          lineHeight: '71px',
          fontWeight: `600 !important`,
          maxWidth: 550,

          '@media(min-width: 900px)': {
            lineHeight: '71px',
          },
        },
        '& .hero-subtitle': {
          fontSize: '18px',
          maxWidth: 520,
        },
      },
      '& .image-wrapper': {
        position: 'relative',
        '@media(min-width: 900px)': {
          bottom: -85,
        },
  
        '& .image': {
          borderRadius: 32,
          boxShadow: 'none',
          
          '@media(min-width: 900px)': {
            height: 726,
            width: 'auto',
          }
        },
      },
    },

    /* Benefits - Styles */
    '& .definition-variant-2': {
      '& .benefits-wrapper': {
        '& .definition-service-title': {
          fontWeight: `600 !important`
        },
        '& .definition-service-description': {
          maxWidth: '320px'
        },
        '& .section-header__title': {
          fontWeight: 'normal',
          paddingBottom: 64,
          '@media(max-width: 900px)': { 
            paddingBottom: 24,
            '& .section-alternate__content': {
              paddingTop: 24
            }
          }
        },
      },
      paddingTop: '0 !important',
      '@media(max-width: 900px)': { 
        paddingTop: 0
      }
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      '& .subscription-bg': {
        height: '100%',
        background: palette.background.subscription
      },
      '& #pricing-benefit-section': {
        '& .section-header__title, .section-header__subtitle': {
          color: palette.text.highlight,
          fontWeight: 'normal'
        },
        '& .planCard': {
          border: 'none',
          '&:hover': {
            border: `1px solid ${palette.primary.main}`,
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.disabled,
          },
          '& .price-value': {
            color: palette.text.primary,
          },
          '& .customGetStarted': {
            width: '96%'
          }
        },
        '& .subscription-tabs-label, .summary-subtext, .summary-text': {
          color: palette.text.highlight
        },
        '& .summary-text': {
          fontSize: 24,
          '@media(max-width: 900px)': {
            fontSize: 18,
          }
        },
        '& .savings-summary-link': {
          textDecoration: 'underline',
          color: palette.text.highlight,
          cursor: 'pointer',
        },
      },
      '& .react-multi-carousel-dot button': {
        background: palette.text.highlight,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        background: palette.text.highlight,
        border: 'none',
        opacity: 1,
      },
      '& .MuiSwitch-thumb': {
        background: palette.primary.main
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.text.highlight,
      '& .howitworks-title': {
        marginBottom: 0,
      },
      '& .how-cover-image': {
        height: 450,
      },
      '& .step-content': {
        maxWidth: 400
      },
      '& .step-counter': {
        borderRadius: '50%',
        backgroundColor: palette.primary.main,
        color: palette.text.highlight,
      },
  
      '& .step-started-button': {
        '& .right-icon': {
          color: palette.text.highlight,
        },
      },
      '@media(max-width: 900px)': {
        '& .how-cover-image': {
          height: '100%',
        },
      }
    },

    /* Testimonial - Styles */
    '& .testimonial-wrapper': {
      background: palette.background.light,

      '& .testimonialSection': {
        paddingLeft: 16
      },

      '& .section-header__overline-wrapper': {
        color: palette.primary.main,
      },

      '& .testimonial-title-wrapper': {
        '& .section-header__title': {
          maxWidth: 600,
        }
      },
      '& .testimonial-container': {
        flexDirection: 'column-reverse',

        '@media(min-width: 900px)': {
          flexDirection: 'row-reverse',
        },
      },
      '& .testimonial-content-wrapper': {
        marginTop: 10,
        '@media(min-width: 900px)': {
          marginTop: -200,
        },
        
        '& .react-multi-carousel-track': {
          paddingTop: 60,
          '@media(min-width: 900px)': {
            paddingTop: 200,
          },
        },
        '& .custom-arrow': {
          border: 0,
          backgroundColor: 'unset',
          top: 0,
          width: 40,
          height: 40,
        },
        '& .left-arrow': {
          right: 75,
          left: 'unset',
        }, 
        '& .testimonial-message': {
          color: palette.text.primary,
          fontFamily: 'OpenSauceSans',
          fontWeight: 400,
        },
      },
      '& .image-wrapper': {
        display: 'flex',
        justifyContent: 'center',

        '@media(min-width: 900px)': {
          justifyContent: 'left',
        },

        '& .image': {
          height: '100%',
          width: 'auto',

          '@media(min-width: 900px)': {
            height: 414,
          },
        }
      }
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .section-header': {
        '& .section-header__title': {
          color: palette.text.primary,
        },
        '& .section-header__subtitle': {
          color: palette.text.primary,
        },
      },
      '& .service-plan-table': {
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .footer-bar-text': {
        color: palette.text.primary
      },
      '& .savings-contact-card': {
        padding: '0px 60px !important',
        background: palette.background.footer,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-title': {
        fontWeight: 'normal'
      },
      '& .hero-static-subtitle': {
        color: palette.text.secondary
      },
      '& .hero-static-bg': {
        backgroundColor: palette.text.highlight,
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        background: palette.background.light,
        border: `1px solid ${palette.primary.main}`,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          border: `1px solid ${palette.primary.main}`,
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.divider,
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
        },
      },
      '& .hero-static-bg': {
        background: `${palette.background.footer} !important`
      },
      '& .primary-static-button': {
        background: palette.primary.main,
      },
      '& .react-multi-carousel-dot button': {
        background: palette.primary.main,
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      '& .hero-header-title, & .hero-header-subtitle': {
        textAlign: 'center',
      },
      '& .header-container': {
        justifyContent: 'center',
        margin: '0',
      },
      '@media(max-width: 900px)': {
        '& .section': {
          marginLeft: 0
        },
      }
    },
    '& .faqInnerContainer': {
      '& .accordion__collapsable-text': {
        color: palette.text.secondary
      },
    },
    '& .faq-contact-section':{
      '& .contact-card-subtitle': {
        color: palette.text.secondary
      }
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'auto',
        fontWeight: 'bold',
      },
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.background.footer,
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
      },
      '& .provider-contact-details': {
        color: palette.text.secondary,
        fontWeight: 400
      }
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.primary.main,
      },
      '& .stepperIconActive': {
        color: `${palette.primary.main} !important`,
        '& .stepperIconText': {
          fill: palette.text.highlight,
        },
      },
      '& .stepperIconRoot': {
        color: 'transparent',
        borderColor: palette.primary.main,
        '& .stepperIconText': {
          fill: palette.primary.main,
        },
      },
      '& .stepperIconCompleted': {
        color: palette.primary.main,
      },
    },

    /* Footer style */
    '& .footer-wrapper': {
      background: palette.text.highlight,
      borderTop: `1px solid ${palette.divider}`,
      color: palette.text.primary,
      '& .footer-link, .copyrights-footer-link': {
        color: palette.text.primary,
      },
      '& .copyrights-footer': {
        borderTop: `1px solid ${palette.divider}`,
      },
    },
  },
};